import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css, keyframes } from '@emotion/react';
import { isMobile } from 'react-device-detect';
import { ALL_BOMB_PROPERTIES } from '../../../../types/bombTypes';
const SCALE = isMobile ? 200 : 150;
const IS_OVER_KEYFRAMES = keyframes `
  0% {
    transform: scale(${SCALE}%) rotate(-20deg);
  }
  50% {
    transform: scale(${SCALE}%) rotate(+20deg);
  }
  100% {
    transform: scale(${SCALE}%) rotate(-20deg);
  }
`;
const IS_OVER_CSS = css `
  animation: ${IS_OVER_KEYFRAMES} 1s infinite;
`;
export const DraggingBombDisplay = ({ bombType, isOverTarget }) => {
    return (_jsx("img", { "data-testid": 'dragging-bomb', src: ALL_BOMB_PROPERTIES[bombType].buttonImageUrl, width: 50, height: 50, css: isOverTarget ? IS_OVER_CSS : undefined }));
};
